// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-profile-calendar-page {
  min-height: 100%;
  padding: 24px;
  background: radial-gradient(circle at top left, rgba(15, 127, 115, 0.14), transparent 34%), radial-gradient(circle at top right, rgba(244, 127, 61, 0.12), transparent 28%), linear-gradient(180deg, #fbf6ee 0%, #f4ead7 100%);
}

.my-profile-calendar-hero {
  border-radius: 22px;
  margin-bottom: 18px;
  background: linear-gradient(135deg, #1f1710 0%, #2d2015 48%, #0f7f73 100%);
  color: #fff;
  box-shadow: 0 18px 42px rgba(34, 24, 16, 0.28);
}

.my-profile-calendar-overline {
  color: #f6ddbf;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-weight: 700;
  font-size: 11px;
}

.my-profile-calendar-title.ant-typography {
  color: #fff2dc;
  margin: 8px 0 0;
}

.my-profile-calendar-subtitle {
  color: #ffe9cc;
  max-width: 820px;
  display: block;
}

.my-profile-calendar-card.ant-card {
  border-radius: 18px;
  border: 1px solid #e6d4bb;
  box-shadow: 0 10px 26px rgba(39, 29, 18, 0.08);
}

.my-profile-calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
}

.my-profile-calendar-grid--header {
  margin-bottom: 8px;
}

.my-profile-calendar-dow {
  text-align: center;
  font-size: 12px;
  color: #7a6a57;
  font-weight: 700;
  padding: 4px 0;
}

.my-profile-calendar-cell {
  min-height: 152px;
  border-radius: 14px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid #eadcc9;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;
}

.my-profile-calendar-cell:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 18px rgba(25, 18, 12, 0.08);
}

.my-profile-calendar-cell--muted {
  opacity: 0.55;
}

.my-profile-calendar-cell--today {
  border-color: #0f7f73;
  box-shadow: inset 0 0 0 1px rgba(15, 127, 115, 0.12);
}

.my-profile-calendar-cell__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.my-profile-calendar-cell__date {
  font-weight: 800;
  color: #2e2318;
}

.my-profile-calendar-cell__count {
  margin: 0;
}

.my-profile-calendar-events {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
}

.my-profile-calendar-event {
  background: #fffdf9;
  border-radius: 10px;
  padding: 7px 8px;
  border-left: 4px solid #d9d9d9;
  box-shadow: 0 1px 2px rgba(27, 19, 11, 0.04);
}

.my-profile-calendar-event__label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #221913;
}

.my-profile-calendar-event__meta {
  display: block;
  font-size: 11px;
  color: #7a6a57;
}

.my-profile-calendar-more {
  font-size: 11px;
  color: #0f7f73;
  font-weight: 700;
}

.my-profile-calendar-legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 999px;
}

@media (max-width: 1200px) {
  .my-profile-calendar-cell {
    min-height: 128px;
  }
}
@media (max-width: 768px) {
  .my-profile-calendar-page {
    padding: 14px;
  }
  .my-profile-calendar-grid {
    gap: 6px;
  }
  .my-profile-calendar-cell {
    min-height: 112px;
    padding: 8px;
  }
  .my-profile-calendar-event__label,
  .my-profile-calendar-event__meta {
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/profile/MyProfileCalendarPage.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,8NACE;AAAJ;;AAKA;EACE,mBAAA;EACA,mBAAA;EACA,0EAAA;EACA,WAAA;EACA,8CAAA;AAFF;;AAKA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,yBAAA;EACA,8CAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,qCAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gFAAA;AAFF;;AAKA;EACE,2BAAA;EACA,8CAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,qBAAA;EACA,oDAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,4CAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAFF;;AAKA;EACE;IACE,iBAAA;EAFF;AACF;AAKA;EACE;IACE,aAAA;EAHF;EAMA;IACE,QAAA;EAJF;EAOA;IACE,iBAAA;IACA,YAAA;EALF;EAQA;;IAEE,eAAA;EANF;AACF","sourcesContent":[".my-profile-calendar-page {\n  min-height: 100%;\n  padding: 24px;\n  background:\n    radial-gradient(circle at top left, rgba(15, 127, 115, 0.14), transparent 34%),\n    radial-gradient(circle at top right, rgba(244, 127, 61, 0.12), transparent 28%),\n    linear-gradient(180deg, #fbf6ee 0%, #f4ead7 100%);\n}\n\n.my-profile-calendar-hero {\n  border-radius: 22px;\n  margin-bottom: 18px;\n  background: linear-gradient(135deg, #1f1710 0%, #2d2015 48%, #0f7f73 100%);\n  color: #fff;\n  box-shadow: 0 18px 42px rgba(34, 24, 16, 0.28);\n}\n\n.my-profile-calendar-overline {\n  color: #f6ddbf;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  font-weight: 700;\n  font-size: 11px;\n}\n\n.my-profile-calendar-title.ant-typography {\n  color: #fff2dc;\n  margin: 8px 0 0;\n}\n\n.my-profile-calendar-subtitle {\n  color: #ffe9cc;\n  max-width: 820px;\n  display: block;\n}\n\n.my-profile-calendar-card.ant-card {\n  border-radius: 18px;\n  border: 1px solid #e6d4bb;\n  box-shadow: 0 10px 26px rgba(39, 29, 18, 0.08);\n}\n\n.my-profile-calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.my-profile-calendar-grid--header {\n  margin-bottom: 8px;\n}\n\n.my-profile-calendar-dow {\n  text-align: center;\n  font-size: 12px;\n  color: #7a6a57;\n  font-weight: 700;\n  padding: 4px 0;\n}\n\n.my-profile-calendar-cell {\n  min-height: 152px;\n  border-radius: 14px;\n  padding: 10px;\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid #eadcc9;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;\n}\n\n.my-profile-calendar-cell:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 18px rgba(25, 18, 12, 0.08);\n}\n\n.my-profile-calendar-cell--muted {\n  opacity: 0.55;\n}\n\n.my-profile-calendar-cell--today {\n  border-color: #0f7f73;\n  box-shadow: inset 0 0 0 1px rgba(15, 127, 115, 0.12);\n}\n\n.my-profile-calendar-cell__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.my-profile-calendar-cell__date {\n  font-weight: 800;\n  color: #2e2318;\n}\n\n.my-profile-calendar-cell__count {\n  margin: 0;\n}\n\n.my-profile-calendar-events {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow: hidden;\n}\n\n.my-profile-calendar-event {\n  background: #fffdf9;\n  border-radius: 10px;\n  padding: 7px 8px;\n  border-left: 4px solid #d9d9d9;\n  box-shadow: 0 1px 2px rgba(27, 19, 11, 0.04);\n}\n\n.my-profile-calendar-event__label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #221913;\n}\n\n.my-profile-calendar-event__meta {\n  display: block;\n  font-size: 11px;\n  color: #7a6a57;\n}\n\n.my-profile-calendar-more {\n  font-size: 11px;\n  color: #0f7f73;\n  font-weight: 700;\n}\n\n.my-profile-calendar-legend-dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n}\n\n@media (max-width: 1200px) {\n  .my-profile-calendar-cell {\n    min-height: 128px;\n  }\n}\n\n@media (max-width: 768px) {\n  .my-profile-calendar-page {\n    padding: 14px;\n  }\n\n  .my-profile-calendar-grid {\n    gap: 6px;\n  }\n\n  .my-profile-calendar-cell {\n    min-height: 112px;\n    padding: 8px;\n  }\n\n  .my-profile-calendar-event__label,\n  .my-profile-calendar-event__meta {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
